import { render, staticRenderFns } from "./YourAppointments.vue?vue&type=template&id=6f55984d"
import script from "./YourAppointments.vue?vue&type=script&lang=js"
export * from "./YourAppointments.vue?vue&type=script&lang=js"
import style0 from "./YourAppointments.vue?vue&type=style&index=0&id=6f55984d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports